import i18n from '@/i18n/i18n'

export const CHECKOUT_CONFIGURATIONS_LIST_ROUTE = 'checkout-configurations-view'
export const CHECKOUT_CONFIGURATIONS_DETAIL_ROUTE = 'checkout-configuration-detail-view'
export const CHECKOUT_DELIVERY_ZONES_ADD_ROUTE = 'checkout-delivery-zones-add'
export const CHECKOUT_DELIVERY_METHOD_ADD_ROUTE = 'checkout-delivery-methods-add'
export const CHECKOUT_DELIVERY_METHOD_EDIT_ROUTE = 'checkout-delivery-methods-edit'
export const TEMPLATE_CHECKOUT_DETAIL_ROUTE = 'template-checkout-detail-view'
export const TEMPLATE_CHECKOUT_DELIVERY_METHOD_ADD_ROUTE = 'template-checkout-delivery-methods-add'
export const TEMPLATE_CHECKOUT_DELIVERY_ZONES_ADD_ROUTE = 'template-checkout-delivery-zones-add'
export const TEMPLATE_CHECKOUT_DELIVERY_METHOD_EDIT_ROUTE = 'template-checkout-delivery-methods-edit'

export default {
  name: 'checkout',
  path: '/checkout',
  redirect: { name: CHECKOUT_CONFIGURATIONS_LIST_ROUTE },
  component: () => import('@/app/checkout/views/CheckoutView.vue'),
  children: [
    {
      name: CHECKOUT_CONFIGURATIONS_LIST_ROUTE,
      path: '/checkout/configurations',
      component: () => import('@/app/checkout/configurations/views/CheckoutOverview.vue'),
      meta: {
        pageTitle: () => 'Dynamic Checkout',
        permissions: ['configure_checkout'],
      },
    },

    {
      name: TEMPLATE_CHECKOUT_DETAIL_ROUTE,
      path: '/checkout/templates/:templateId',
      component: () => import('@/app/checkout/delivery-zones/views/TemplateDeliveryZoneListView.vue'),
      props: route => ({
        templateId: route.params.templateId,
        openSectionDeliveryZoneId: route.query.openSectionDeliveryZoneId,
      }),
      meta: {
        pageTitle: () => 'Dynamic Checkout',
        permissions: ['configure_checkout'],
        backLinkRoute() {
          return {
            title: i18n.t('Go back to checkout overview'),
            to: { name: CHECKOUT_CONFIGURATIONS_LIST_ROUTE },
          }
        },
      },
    },

    {
      name: CHECKOUT_CONFIGURATIONS_DETAIL_ROUTE,
      path: '/checkout/configurations/:integrationId',
      component: () => import('@/app/checkout/delivery-zones/views/DeliveryZoneListView.vue'),
      props: route => ({
        integrationId: route.params.integrationId,
        openSectionDeliveryZoneId: route.query.openSectionDeliveryZoneId,
      }),
      meta: {
        pageTitle: () => 'Dynamic Checkout',
        permissions: ['configure_checkout'],
        backLinkRoute() {
          return {
            title: i18n.t('Go back to Dynamic Checkout configurations'),
            to: { name: CHECKOUT_CONFIGURATIONS_LIST_ROUTE },
          }
        },
      },
    },

    {
      name: CHECKOUT_DELIVERY_ZONES_ADD_ROUTE,
      path: '/checkout/configurations/:integrationId/delivery-zones/new',
      component: () => import('@/app/checkout/delivery-zones/views/DeliveryZoneFormView.vue'),
      props: route => ({
        integrationId: route.params.integrationId,
      }),
      meta: {
        pageTitle: () => i18n.t('New delivery zone'),
        permissions: ['configure_checkout'],
        backLinkRoute(route) {
          return {
            title: i18n.t('Go back to the Dynamic Checkout configuration'),
            to: { name: CHECKOUT_CONFIGURATIONS_DETAIL_ROUTE, params: { integrationId: route.params.integrationId } },
          }
        },
      },
    },

    {
      name: TEMPLATE_CHECKOUT_DELIVERY_ZONES_ADD_ROUTE,
      path: '/checkout/configurations/:templateId/delivery-zones/new',
      component: () => import('@/app/checkout/delivery-zones/views/TemplateDeliveryZoneFormView.vue'),
      props: route => ({
        templateId: route.params.templateId,
      }),
      meta: {
        pageTitle: () => i18n.t('New delivery zone'),
        permissions: ['configure_checkout'],
        backLinkRoute(route) {
          return {
            title: i18n.t('Go back to template configuration'),
            to: {
              name: TEMPLATE_CHECKOUT_DETAIL_ROUTE,
              params: {
                templateId: route.params.templateId,
                openSectionDeliveryZoneId: route.query.openSectionDeliveryZoneId,
              },
            },
          }
        },
      },
    },

    {
      name: TEMPLATE_CHECKOUT_DELIVERY_METHOD_ADD_ROUTE,
      path: '/checkout/templates/:templateId/delivery-zones/:deliveryZoneId/delivery-methods/new',
      component: () => import('@/app/checkout/delivery-methods/views/TemplateDeliveryMethodFormView.vue'),
      props: route => ({
        deliveryZoneId: route.params.deliveryZoneId,
        templateId: route.params.templateId,
        deliveryMethodType: route.query.type,
      }),
      meta: {
        pageTitle: () => i18n.t('New delivery method'),
        permissions: ['configure_checkout'],
        backLinkRoute(route) {
          return {
            title: i18n.t('Go back to template configuration'),
            to: {
              name: TEMPLATE_CHECKOUT_DETAIL_ROUTE,
              params: { integrationId: route.params.templateId },
            },
          }
        },
      },
    },

    {
      name: TEMPLATE_CHECKOUT_DELIVERY_METHOD_EDIT_ROUTE,
      path: '/checkout/templates/:templateId/delivery-zones/:deliveryZoneId/delivery-methods/:deliveryMethodId',
      component: () => import('@/app/checkout/delivery-methods/views/TemplateDeliveryMethodFormView.vue'),
      props: route => ({
        templateId: route.params.templateId,
        deliveryZoneId: route.params.deliveryZoneId,
        deliveryMethodId: route.params.deliveryMethodId,
        deliveryMethodType: route.query.type,
      }),
      meta: {
        pageTitle: () => i18n.t('Edit delivery method'),
        permissions: ['configure_checkout'],
        backLinkRoute(route) {
          return {
            title: i18n.t('Go back to template configuration'),
            to: {
              name: TEMPLATE_CHECKOUT_DETAIL_ROUTE,
              params: { integrationId: route.params.integrationId },
            },
          }
        },
      },
    },

    {
      name: CHECKOUT_DELIVERY_METHOD_ADD_ROUTE,
      path: '/checkout/configurations/:integrationId/delivery-zones/:deliveryZoneId/delivery-methods/new',
      component: () => import('@/app/checkout/delivery-methods/views/DeliveryMethodFormView.vue'),
      props: route => ({
        deliveryZoneId: route.params.deliveryZoneId,
        integrationId: route.params.integrationId,
        deliveryMethodType: route.query.type,
      }),
      meta: {
        pageTitle: () => i18n.t('New delivery method'),
        permissions: ['configure_checkout'],
        backLinkRoute(route) {
          return {
            title: i18n.t('Go back to the Dynamic Checkout configuration'),
            to: { name: CHECKOUT_CONFIGURATIONS_DETAIL_ROUTE, params: { integrationId: route.params.integrationId } },
          }
        },
      },
    },

    {
      name: CHECKOUT_DELIVERY_METHOD_EDIT_ROUTE,
      path: '/checkout/configurations/:integrationId/delivery-zones/:deliveryZoneId/delivery-methods/:deliveryMethodId',
      component: () => import('@/app/checkout/delivery-methods/views/DeliveryMethodFormView.vue'),
      props: route => ({
        integrationId: route.params.integrationId,
        deliveryZoneId: route.params.deliveryZoneId,
        deliveryMethodId: route.params.deliveryMethodId,
        deliveryMethodType: route.query.type,
      }),
      meta: {
        pageTitle: () => i18n.t('Edit delivery method'),
        permissions: ['configure_checkout'],
        backLinkRoute(route) {
          return {
            title: i18n.t('Go back to the Dynamic Checkout configuration'),
            to: { name: CHECKOUT_CONFIGURATIONS_DETAIL_ROUTE, params: { integrationId: route.params.integrationId } },
          }
        },
      },
    },
  ],
  meta: {
    pageTitle: () => 'Dynamic Checkout',
  },
}
